import React from 'react'
//import React, { useEffect } from 'react'
import styles from './index.module.less'
//import Media from '../../components/Media'
import Partners from '../../components/Partners'
// import { useNavigate } from 'react-router-dom'
import QueueAnim from 'rc-queue-anim'
import { BackTop } from 'antd' //notification  //message
//import Guests from '../../components/Guests'
import CountUp from 'react-countup'


export default function Home() {
  //const navigate = useNavigate()

  // useEffect(() => {
  //   const d = new Date(2023, 11 - 1, 23).valueOf() - Date.now()//月份要减一，月的取值是0-11
  //   const day = Math.floor(d / 1000 / 3600 / 24)
  //   notification.open({
  //     message: 'iMFG中国智造峰会',
  //     description: <p>距2023届峰会还有<span style={{ color: '#5593FF' }}>{day}</span>天</p>,
  //     duration: 4,
  //   })
  // }, [])


  return (
    <>
      <BackTop />
      {/* 大图 */}
      <div className={styles.big_img}>
        <QueueAnim type='scaleY' delay={200} duration={500} interval={100} forcedReplay={true} className={styles.cont}>
          <h1 key='1'>iMFG智能制造峰会</h1>
          <h2 key='2'>2025.6.19 上海</h2>
          {/* <h3 key='3'>上海</h3> */}
          <section key='3'>
            智数齐驱 造通全球<br />
            <span>
              <span style={{ fontWeight: '700' }}>150+</span>
              制造行业精英定向邀请已开启！</span>
          </section>
          {/* <button onClick={() => { navigate('/enroll') }}>报名</button>*/}
          {/* navigate('/enroll'); message.info('合作请联系') */}

          <button onClick={()=>{document.getElementById('bottomAd').scrollIntoView(false);}} >报名</button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button onClick={() => { document.getElementById('bottomAd').scrollIntoView(false); }}>合作</button><br />

          <img key='5' src="https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/huiyu_logoblue.png" width={150} alt="" />
        </QueueAnim>
      </div>
      {/* 会议介绍 */}
      <div className={styles.info_area}>
        <div className={styles.itemCard}>
          <div className={styles.card}>
            <div className={styles.icon}>
              <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/building.png" alt="" />
            </div>
            <div className={styles.icon}>
              <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/table.png" alt="" />
            </div>
            <div className={styles.icon}>
              <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/user.png" alt="" />
            </div>
          </div>
        </div>
        <div className={styles.count}>
          <div className={styles.item}>
            <div className={styles.numArea}>
              <CountUp redraw={true} start={0} end={10} duration={6} className={styles.num} />
              <span>+</span>
            </div>
            <span className={styles.text}>案例展示</span>
          </div>
          <div className={styles.item}>
            <div className={styles.numArea}>
              <CountUp redraw={true} start={0} end={50} duration={6} className={styles.num} />
              <span>+</span>
            </div>
            <span className={styles.text}>先锋企业</span>
          </div>
          <div className={styles.item}>
            <div className={styles.numArea}>
              <CountUp redraw={true} start={0} end={150} duration={6} className={styles.num} />
              <span>+</span>
            </div>
            <span className={styles.text}>行业精英</span>
          </div>
        </div>
        <div style={{ backgroundColor: '#F4F9FE', padding: '60px 0' }}>
          <section className={styles.intro}>
            <div className={styles.title}><span>iMFG制造</span></div>
            <div className={styles.cont}>
              <div className={styles.left}>
                <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/zhizao.jpg" alt="" />
              </div>
              <div className={styles.right}>
                <p>
                  在新一轮信息技术与制造技术深度融合，新一代移动互联网技术以及大数据、云计算技术发展应用的背景下，中国制造业也亟需通过智能制造来完成新一轮制造业的战略转型。iMFG中国智造峰会是会誉会展自2021年重点推出的品牌系列峰会，6月19日上海，iMFG再度强势来袭，与百家新能源制造厂商有关IT、制造、质量、采购等150位部门高层共同加速推动中国制造数字化、网络化与智能化。
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
      {/* 会议亮点 */}
      <div className={styles.blips}>
        <span className={styles.big_title}>会议亮点</span>
        <div className={styles.box}>
          <div className={styles.item}>
            <div className={styles.imgbox}>
              <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/imgs/meet2.jpg" alt="" />
            </div>
            <div>
              <p>聊·业话</p>
              <p  className={styles.p2}>iMFG为发言嘉宾提供向200+业界菁英分享独家叙事、观点牵引和创新项目展示的绝佳机会！独享并抢占150+领头企业C-level领导心智与合作先机，思想碰撞不限维度。</p>
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.imgbox}>
              <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/imgs/meet1.jpg" alt="" />
            </div>
            <div>
              <p>展·品牌</p>
              <p  className={styles.p2}>iMFG向全国优秀科技企业递送邀请函，打造沉浸式数字化成果展示大舞台。在这里，创新产品和服务大放异彩、交相辉映；在这里，科技创新聚焦企业需求并契合连接；在这里，企业升级能量不限容，创新成果持续影响、品牌实力向上生长。 </p>
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.imgbox}>
              <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/imgs/meet6.jpg" alt="" />
            </div>
            <div>
              <p>拓·人脉</p>
              <p  className={styles.p2}>iMFG汇集来自汽车、钢铁、机械等诸多行业专家，助力提升个人高度，在智能制造社群中编织柔韧有力的人际网络。iMFG为您磁吸潜在合作伙伴、投资者、客户，拓展商缘持续影响。</p>
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.imgbox}>
              <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/imgs/meet4.jpg" alt="" />
            </div>
            <div>
              <p>汇·合作</p>
              <p  className={styles.p2}>iMFG捕捉每一个可能的商业合作机会，持续探索合作密码。我们在各品牌代表之间摆渡求索，力在提升沟通效率与合作体验，让对话和合作升温，让进步和互利燃势，精准增效提质，合作流畅不限速。</p>
            </div>
          </div>
        </div>
      </div >

      {/* 新闻资讯区域 */}
      {/* < Media /> */}
      {/* 嘉宾列表 */}
      {/* <Guests /> */}
      {/* 报名区域 */}
      <div  className={styles.enroll_area} >
        <div className={styles.top}>
          <div className={styles.item}>
            <div>
              <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/enroll1.png" alt="" />
            </div>
            闭门高层会议

          </div>
          <div className={styles.item}>
            <div>
              <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/enroll2.png" alt="" />
            </div>
            闭门项目交流
          </div>
          <div className={styles.item}>
            <div>
              <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/enroll3.png" alt="" />
            </div>
            主题演讲分享
          </div>
          <div className={styles.item}>
            <div>
              <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/enroll4.png" alt="" />
            </div>
            圆桌讨论
          </div>
          <div className={styles.item}>
            <div>
              <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/enroll5.png" alt="" />
            </div>
            大会全方面宣传推广
          </div>
          <div className={styles.item}>
            <div>
              <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/enroll6.png" alt="" />
            </div>
            意向客户定向邀请
          </div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.left}>
            <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/v2_imgs/enroll4.png" alt="" />
          </div>
          <div className={styles.right}>
            <p>报名参加会议</p>
            <p><a className={styles.subchild} href='http://t1.ink/f/upp1av'>报名参加会议&nbsp;&gt;</a></p>
            {/* <p onClick={() => { window.location.href("http://t1.ink/f/upp1av") }}>报名参加会议&nbsp;&gt;</p> */}
          </div>


        </div>
      </div>
      {/* 合作媒体 */}
      <div className={styles.media} >
        <span className={styles.big_title}>合作媒体</span>
        <img src="https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets%2Fv2_imgs%2Fmedia.jpg" alt="" />
        {/* <button className={styles.more_btn} onClick={() => { navigate('/vendors') }}>更多&gt;</button> */}
      </div >
      {/* 合作伙伴 */}
      <div className={styles.partners} >
        <span className={styles.big_title}>合作伙伴</span>
        <Partners />
        {/* <button className={styles.more_btn} onClick={() => { navigate('/vendors') }}>更多&gt;</button> */}
      </div >
      <div id='bottomAd' style={{marginBottom:'-4rem',height:'4rem'}}></div>
    </>
  )
}
